import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { COOKING_STEP_TAB_NAME, RECIPE_TAB } from '../../constant';
import { RecipeType } from '../../services/recipeTypes';
import EditItemIcon from '../../shared/EditItemIcon';

const CookingStepsListTab: React.FC = () => {
    const { i18n } = useTranslation();
    const recipeTypes = Object.values(RecipeType);

    return (
        <article className="recipe__article-item">
            <ul className="recipe__list">
                {recipeTypes.map((recipeType) => (
                    <li key={recipeType} className="recipe__list-item">
                        <h3 className="main__subtitle recipe__list-content">
                            {i18n.t(`recipe.item.type.${recipeType}`)}
                        </h3>
                        <p className="block__content recipe__list-content">{recipeType}</p>
                        <div className="recipe__list-icons">
                            <Link to={`/${RECIPE_TAB}/${COOKING_STEP_TAB_NAME}/${recipeType}/`}>
                                <EditItemIcon />
                            </Link>
                        </div>
                    </li>
                ))}
            </ul>
        </article>
    );
};

export default CookingStepsListTab;
